"use strict";
angular.module('initVideoDataModule', []).
factory('initVideoDataService', [function() {
    return {
        getOriginData: function(nodeId) {
            var type;
            if (nodeId.indexOf("navigation_002004") >= 0) {
                type = 'jtcpg';
            } else if (nodeId.indexOf("navigation_002007") >= 0) {
                type = 'gxgk';
            } else if (nodeId.indexOf("navigation_002003") >= 0) {
                type = 'szb';
            }
            var originData = {
                "gxgk": {
                    channelName: "gxgk",
                    typeName: "",
                    indexName: "",
                    type: "gxgk"
                },
                "jtcpg": {
                    channelName: "jtcpg",
                    typeName: "jt_lyzh",
                    indexName: "weixin_formal,product_formal,weibo_formal",
                    type: "jtcpg"
                },
                "szb": {
                    channelName: "tpg",
                    typeName: "szb",
                    indexName: "szb_bmt",
                    type: "szb"
                }
            };
            return originData[type];
        }
    };
}]);
